import React from 'react'
import {ColumnInstance} from 'react-table'

/**
 * Componente para renderizar un encabezado de columna personalizado en una tabla que utiliza `react-table`.
 *
 * Este componente toma una instancia de columna de `react-table` y la renderiza. Si el encabezado de la columna
 * es una cadena de texto, se renderiza dentro de un elemento `<th>` con las propiedades apropiadas. Si el encabezado
 * es un componente o una función de renderizado, se renderiza directamente.
 *
 * @param {Props<T>} props - Propiedades del componente.
 * @param {ColumnInstance<T>} props.column - Instancia de la columna de `react-table` que se va a renderizar.
 * @returns {React.FC<Props<T>>} Un componente funcional de React que renderiza el encabezado de una columna.
 *
 * @example
 * // Uso en una tabla de `react-table`
 * columns.map((column: ColumnInstance<T>) => (
 *   <CustomHeaderColumn key={column.id} column={column} />
 * ))
 */

type Props<T extends object> = {
    column: ColumnInstance<T>
}

function CustomHeaderColumn<T extends object>({column}: Props<T>) {
    return (
        <>
            {column.Header && typeof column.Header === 'string' ? (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            ) : (
                column.render('Header')
            )}
        </>
    )
}

export {CustomHeaderColumn}
